
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[userName]/certifications/[assertionId]",
      function () {
        return require("private-next-pages/user/[userName]/certifications/[assertionId].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[userName]/certifications/[assertionId]"])
      });
    }
  